module.exports = __webpack_public_path__ + "img/pinVermelho.3da980e7.png";